import { getCookie, setCookie1sec } from 'utils/setCookies';
import {
  API_REQUEST,
  APP_TRACK_MIX_PANEL,
  APP_TRACK_MIX_PANEL_PEOPLE_INCREMENT
} from './constants/action-types';

export function trackMixPanel(mixPanelObjects) {
  return {
    type: APP_TRACK_MIX_PANEL,
    payload: {
      mixPanelObjects: Array.isArray(mixPanelObjects) ? mixPanelObjects : [mixPanelObjects]
    }
  };
}

export function peopleincrement(data) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/ItemEvent/mixpanel/peopleincrement?distinctId=${getCookie('gtm_account')}`,
      method: 'post',
      data,
      getwayName: 'rapnetitemanalytics',
      nextActionType: APP_TRACK_MIX_PANEL_PEOPLE_INCREMENT
    }
  };
}
